<template>
  <div id="app">
    <div class="page-container">
      <router-view />
    </div>
    <!-- 自定义底部导航栏（仅首页/消息/服务/小慧/我的 5个主tab显示，任何子页面跳转后隐藏） -->
    <nav class="tab-bar" v-if="showTabBar">
      <div
        v-for="tab in tabs"
        :key="tab.path"
        :class="['tab-item', { active: isActive(tab), center: tab.center }]"
        @click="switchTab(tab)"
      >
        <template v-if="tab.center">
          <div class="tab-center-btn">
            <img :src="tab.iconActive" class="center-icon-img" alt="服务" />
          </div>
          <span class="tab-label">{{ tab.label }}</span>
        </template>
        <template v-else>
          <img :src="isActive(tab) ? tab.iconActive : tab.iconInactive" class="tab-icon-img" :alt="tab.label" />
          <span class="tab-label">{{ tab.label }}</span>
        </template>
      </div>
    </nav>
    <!-- 全局页面跳转 loading 遮罩（跨页面存活，由 utils/loading 触发） -->
    <div class="app-loading-mask" v-if="loadingState.visible">
      <div class="app-loading-box">
        <div class="app-loading-spinner"></div>
        <div class="app-loading-text">加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { loadingState } from '@/utils/loading'

export default {
  name: 'App',
  data() {
    return {
      // 全局跳转 loading 状态（独立 store，齿轮/头部箭头等入口跳转时显示）
      loadingState,
      tabs: [
        {
          label: '首页',
          path: '/home',
          iconInactive: require('@/assets/tabbar/home-inactive.png'),
          iconActive: require('@/assets/tabbar/home-active.png')
        },
        {
          label: '消息',
          path: '/message',
          iconInactive: require('@/assets/tabbar/msg-inactive.png'),
          iconActive: require('@/assets/tabbar/msg-active.png')
        },
        {
          label: '服务',
          path: '/service',
          center: true,
          iconActive: require('@/assets/tabbar/service-active.png')
        },
        {
          label: '小慧',
          path: '/xiaohui',
          iconInactive: require('@/assets/tabbar/xiaohui-inactive.png'),
          iconActive: require('@/assets/tabbar/xiaohui-active.png')
        },
        {
          label: '我的',
          path: '/mine',
          iconInactive: require('@/assets/tabbar/mine-inactive.png'),
          iconActive: require('@/assets/tabbar/mine-active.png')
        }
      ]
    }
  },
  computed: {
    // 仅 5 个主 tab 页显示底部导航；进入任何子页面（如社保卡信息查询）即隐藏
    showTabBar() {
      return this.tabs.some(t => t.path === this.$route.path)
    }
  },
  methods: {
    isActive(tab) {
      return this.$route.path === tab.path
    },
    switchTab(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path)
      }
    }
  }
}
</script>

<style>
/* 打包进APK的本地子集字体（思源黑体裁剪，仅项目用字，309KB），
   保证所有设备/浏览器/WebView使用同一字体度量，表格列宽完全一致 */
@font-face {
  font-family: 'RSJ Sans';
  src: url('./assets/fonts/rsj-sans.woff2') format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
:root {
  --w: calc(100vw / 1080);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  /* 禁用Android WebView点击元素时的灰色高亮块（APK内input/可点区域不再出现阴影） */
  -webkit-tap-highlight-color: transparent;
  /* 全站隐藏滚动条外观但保留滚动能力（Firefox/旧Edge，移动端风格） */
  scrollbar-width: none;
  -ms-overflow-style: none;
}
/* WebKit 内核：滚动条完全不显示 */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  display: none;
}
html,
body {
  width: 100%;
  overflow-x: hidden;
  /* 禁止WebView字体自动放大（font boosting），小字号表格文字按CSS原值渲染 */
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
  /* 统一使用打包的本地子集字体，兜底系统字体栈，彻底消除WebView/浏览器字体度量差异 */
  font-family: 'RSJ Sans', system-ui, -apple-system, 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  /* 固定行高：WebView默认行高与浏览器不一致，极易文字重叠 */
  line-height: 1.5;
}
#app {
  font-family: 'RSJ Sans', 'PingFang SC', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: #323233;
  /* 用100%代替100vw：100vw会把纵向滚动条宽度计入导致横向溢出 */
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 明确白底：物理像素取整时任何缝隙均为白色，与tabbar一致 */
  background: #fff;
}
.page-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* 底部导航栏 */
.tab-bar {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  /* 单行严格占满容器高度，防止被中间凸起圆撑高而影响其他tab对齐 */
  grid-template-rows: 100%;
  height: calc(150 * var(--w));
  background: #fff;
  border-top: 1px solid #e5e5e5;
  /* 向上的柔和投影 + 向下2px白色实影带：消除高DPR物理像素取整产生的上下缝隙 */
  box-shadow: 0 calc(-2 * var(--w)) calc(8 * var(--w)) rgba(0,0,0,0.06), 0 2px 0 #fff;
  position: relative;
  z-index: 100;
  flex-shrink: 0;
  /* 向上重叠1px覆盖内容区与tabbar之间的取整接缝（灰色顶边本就存在，视觉无变化） */
  margin-top: -1px;
}
.tab-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* 普通tab：图标+文字在导航栏内垂直居中，上下间距一致 */
  justify-content: center;
  color: #999;
  cursor: pointer;
  position: relative;
}
.tab-item.active {
  color: #00BFA5;
}
.tab-item.center {
  /* 中间tab：圆形与文字均绝对定位，互不影响，便于文字与普通tab精确对齐 */
  justify-content: flex-start;
}
.tab-icon-img {
  width: calc(48 * var(--w));
  height: calc(48 * var(--w));
  object-fit: contain;
}
.tab-item.center .tab-center-btn {
  position: absolute;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  /* 圆形底部距tabbar底边42w，与原视觉位置完全一致（圆顶突出约52w） */
  bottom: calc(42 * var(--w));
  width: calc(140 * var(--w));
  height: calc(140 * var(--w));
  border-radius: 50%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* 中间凸起圆的柔和投影：用 box-shadow 替代原 clip-path 伪元素方案
   （原方案在 60% 处横向截断模糊边，APK 高分辨率下呈现为圆钮下方一条横线） */
.tab-item.center .tab-center-btn {
  box-shadow: 0 calc(-6 * var(--w)) calc(14 * var(--w)) calc(2 * var(--w)) rgba(0,0,0,0.08);
}
.center-icon-img {
  position: relative;
  z-index: 2;
  width: calc(102 * var(--w));
  height: calc(102 * var(--w));
  object-fit: contain;
}
.tab-label {
  font-size: calc(20 * var(--w));
  margin-top: calc(8 * var(--w));
  margin-bottom: 0;
}
.tab-item.center .tab-label {
  position: absolute;
  left: 0;
  right: 0;
  /* 文字底部距tabbar底边22w，实测与首页、消息等文字精确平齐 */
  bottom: calc(22 * var(--w));
  margin: 0;
  text-align: center;
}

/* 全局跳转 loading 遮罩（不透明白底：loading 期间完全盖住新页面，结束才展示） */
.app-loading-mask {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.app-loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.app-loading-spinner {
  width: calc(72 * var(--w));
  height: calc(72 * var(--w));
  border: calc(6 * var(--w)) solid rgba(46, 140, 246, 0.2);
  border-top-color: #2E8CF6;
  border-radius: 50%;
  animation: app-loading-rotate 0.8s linear infinite;
}
.app-loading-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
@keyframes app-loading-rotate {
  to { transform: rotate(360deg); }
}

</style>



// WEBPACK FOOTER //
// src/App.vue